import { render, staticRenderFns } from "./RenderVHtml.vue?vue&type=template&id=9a2f2060&scoped=true"
import script from "./RenderVHtml.vue?vue&type=script&lang=js"
export * from "./RenderVHtml.vue?vue&type=script&lang=js"
import style0 from "@/utils/rich_text_editor.css?vue&type=style&index=0&id=9a2f2060&prod&scoped=true&lang=css&external"
import style1 from "./RenderVHtml.vue?vue&type=style&index=1&id=9a2f2060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2f2060",
  null
  
)

export default component.exports